module.exports = __webpack_public_path__ + "static/media/puntos_grises.e632a575.png";